import React, { useEffect, useState, useCallback } from "react";
import { Toast } from "../../../config/Toast";
import { toast } from "react-toastify";
import ActionComplainWages from "./action";
import TableComplainWages from "./table/table";
import PostingComplainWages from "./modals/Posting";
import ComplaintDeductionService from "../../../services/ComplaintDeduction";
import moment from "moment";

function SalaryCutComplainWages() {
  const [rowData, setRowData] = useState([]);

  // Payload State
  const limitDataPages = 10;
  const [pageNumber, setPageNumber] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [search, setSearch] = useState("");
  const [payload, setpayload] = useState({
    sortBy: null,
    sortType: null,
    amount: 0,
    deduction: null,
    deductionNote: null,
  });

  // Loading State
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [loadingPost, setLoadingPost] = useState(false);
  const [loading, setLoading] = useState(false);

  // Pagination
  const [totalPage, setTotalPage] = useState(0);

  // Modal
  const [modalPosting, setModalPosting] = useState(false);

  const notifySuccess = useCallback((message) => toast.success(message, Toast), []);
  const notifyFailed = useCallback((message) => toast.error(message, Toast), []);

  const handleDateChange = useCallback((dates) => {
    if (dates?.length === 2) {
      setStartDate(moment(dates[0]).format("YYYY-MM-DD"));
      setEndDate(moment(dates[1]).format("YYYY-MM-DD"));
      setPageNumber(1);
    }
  }, []);

  const handleSearch = useCallback((value) => {
    setSearch(value);
    setPageNumber(1);
  }, []);

  const fetchData = useCallback(async () => {
    if (!startDate || !endDate) return;

    setLoading(true);

    const sortBy = payload.sortBy;
    const sortType = payload.sortType;
    const isBookmark = payload.isBookmark;
    const minInitialAmount = payload.amount;
    const isDeduction = payload.deduction;
    const installmentType = payload.deductionNote;

    try {
      const res = await ComplaintDeductionService.list(
        pageNumber,
        limitDataPages,
        search,
        startDate,
        endDate,
        sortBy,
        sortType,
        isBookmark,
        minInitialAmount,
        isDeduction,
        installmentType
      );
      const { data = [], total_page = 0 } = res.data;
      setRowData(data);

      setTotalPage(total_page);
    } catch (err) {
      console.error(err);
      setRowData([]);
      setTotalPage(0);
      notifyFailed(err.response.data.message || "Gagal memuat data");
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, pageNumber, search, notifyFailed, payload]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = useCallback(async () => {
    if (!startDate || !endDate) return notifyFailed("Periode rentang waktu tidak boleh kosong");
    setLoadingFilter(true);
    await fetchData();
    setLoadingFilter(false);
  }, [startDate, endDate, fetchData, notifyFailed]);

  const handOpenModalPost = useCallback(() => {
    if (!startDate || !endDate) {
      return notifyFailed("Periode rentang waktu tidak boleh kosong");
    }
    setModalPosting(true);
  }, [startDate, endDate, notifyFailed]);

  const handlePost = useCallback(async () => {
    if (!startDate || !endDate) return notifyFailed("Periode rentang waktu tidak boleh kosong");
    setLoadingPost(true);
    try {
      await ComplaintDeductionService.post({ start_date: startDate, end_date: endDate });
      notifySuccess("Upah tukang berhasil di rekap");
      fetchData();
    } catch {
      notifyFailed("Gagal posting data");
    } finally {
      setLoadingPost(false);
    }
  }, [startDate, endDate, notifySuccess, notifyFailed, fetchData]);

  const closeAllModals = useCallback(() => {
    setModalPosting(false);
  }, []);

  const handleChangePage = useCallback(({ value }) => {
    setPageNumber(value);
  }, []);

  const handleHeaderChange = (payload) => {
    setpayload((prev) => ({
      ...prev,
      ...payload,
    }));
  };

  return (
    <div className="w-100 d-flex flex-column gap-3">
      {modalPosting && (
        <PostingComplainWages activeModal={modalPosting} closeModal={closeAllModals} onConfirm={handlePost} />
      )}
      <div>
        <ActionComplainWages
          rangeDate={[startDate ? moment(startDate).toDate() : null, endDate ? moment(endDate).toDate() : null]}
          onDateChange={(dates) => handleDateChange(dates)}
          onFilter={handleFilter}
          onPost={handOpenModalPost}
          onSearch={handleSearch}
          loadingFilter={loadingFilter}
          loadingPost={loadingPost}
        />
      </div>
      <div className="flex w-100 h-100">
        <TableComplainWages
          data={loading ? [] : rowData}
          totalPage={totalPage}
          onChange={handleHeaderChange}
          handleOnChangePage={handleChangePage}
          getNewData={fetchData}
          pageNumber={pageNumber}
          limitDataPages={limitDataPages}
        />
      </div>
    </div>
  );
}

export default SalaryCutComplainWages;
